export const HOME_SECTION_TYPES = {
  bannerCarousel: "BANNER_CAROUSEL",
  iconGrid: "ICON_GRID",
};

export const HOME_ITEM_IDS = {
  purchaseOrders: "purchase_orders",
  planShipment: "plan_shipment",
  directDelivery: "direct_delivery",
  grnPayments: "grn_payments",
  payouts: "payouts",
};

export const BADGE_MAX_COUNT = 100;
